








































import { defineComponent, ref, computed } from '@vue/composition-api';
import type { CouponRolePo } from '@/api/coupon/types';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import CouponSelectModal from '../coupon-select-modal/index.vue';
import { TP_QUICK_WITHDRAW_CARD_COUPON_CATEGORY } from '../../tianqi';


// static component
// [功能说明]: 优惠信息展示组件
interface Props {
  label?: string;
  couponList?: CouponRolePo[];
  selectedCoupon?: CouponRolePo | null;
  containerHeight?: number;
}

export default defineComponent({
  name: 'DiscountItem',
  components: {
    CouponSelectModal,
    RightArrowOutline12,
  },
  props: {
    label: {
      type: String,
      default: '优惠',
    },
    couponList: {
      type: Array as () => CouponRolePo[],
      default: () => [],
    },
    selectedCoupon: {
      type: Object as () => CouponRolePo | null,
      default: null,
    },
    containerHeight: {
      type: Number,
      default: 0,
    },
  },
  emits: ['coupon-select', 'no-coupon'],
  setup(props: Props, { emit }) {
    const showCouponModal = ref(false);

    // 计算属性：判断是否显示组件（内聚逻辑）
    const shouldShow = computed(() => {
      if (props.couponList && props.couponList.length > 0) {
        ubtSetupModuleExpose(TP_QUICK_WITHDRAW_CARD_COUPON_CATEGORY);
        return true;
      }
      return false;
    });

    // 计算属性：分离可用和不可用优惠券
    const availableCouponList = computed(() => {
      const coupons = props.couponList || [];
      return coupons.filter((coupon) => coupon.availability === true);
    });

    const unavailableCouponList = computed(() => {
      const coupons = props.couponList || [];
      return coupons.filter((coupon) => coupon.availability === false);
    });

    // 获取优惠券显示文本
    const getCouponDisplayText = (coupon: CouponRolePo): string => coupon.couponName || `${coupon.amount}元优惠券`;

    // 计算属性：显示文本
    const displayValue = computed(() => {
      // 如果有选中的优惠券，显示优惠券信息
      if (props.selectedCoupon && props.selectedCoupon.amount) {
        return getCouponDisplayText(props.selectedCoupon);
      }

      // 根据可用优惠券数量显示提示
      const availableCount = availableCouponList.value.length;
      return availableCount > 0 ? `${availableCount}张可用` : '暂无优惠';
    });

    // 处理点击事件
    const handleClick = () => {
      ubtSetupPageButton(TP_QUICK_WITHDRAW_CARD_COUPON_CATEGORY);
      // 如果没有优惠券，不显示弹窗
      if (!props.couponList || props.couponList.length === 0) {
        return;
      }
      showCouponModal.value = true;
    };

    // 处理关闭弹窗
    const handleCloseModal = () => {
      showCouponModal.value = false;
    };

    // 处理选择优惠券
    const handleSelectCoupon = (coupon: CouponRolePo, index: number, isAvailable: boolean) => {
      showCouponModal.value = false;
      emit('coupon-select', coupon, index, isAvailable);
    };

    // 处理不选择优惠券
    const handleNoCoupon = () => {
      showCouponModal.value = false;
      emit('no-coupon');
    };

    return {
      props,
      selectedCoupon: computed(() => props.selectedCoupon),
      shouldShow,
      showCouponModal,
      availableCouponList,
      unavailableCouponList,
      displayValue,
      handleClick,
      handleCloseModal,
      handleSelectCoupon,
      handleNoCoupon,
      containerHeight: props.containerHeight,
    };
  },
});
